import { ReactNode, useEffect, useState } from 'react';
import { Sidebar } from './Sidebar';
import { Button } from '../ui/button';
import { ChevronsLeftRight, ChevronsRightLeft, Menu, X } from 'lucide-react';
import { cn } from '@/utils';
import { useLocation } from 'react-router-dom';

export default function Layout({ children }: { children: ReactNode }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [pathname]);

  return (
    <div className="flex">
      <Button
        variant="outline"
        size="icon"
        className="fixed top-3 left-3 z-40 md:hidden"
        onClick={() => setIsMobileMenuOpen(true)}
        aria-label="Open navigation menu"
      >
        <Menu className="h-5 w-5" />
      </Button>

      <div
        className={cn(
          'fixed inset-0 z-50 md:hidden transition-opacity duration-200',
          isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        )}
        aria-hidden={!isMobileMenuOpen}
      >
        <div className="absolute inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)} />
        <div
          className={cn(
            'absolute inset-y-0 left-0 w-[280px] bg-card transition-transform duration-300',
            isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
          )}
          onClick={e => e.stopPropagation()}
        >
          <Button
            variant="ghost"
            size="icon"
            className="absolute top-3 right-3 z-10"
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Close navigation menu"
          >
            <X className="h-5 w-5" />
          </Button>
          <Sidebar isCollapsed={false} mobile onNavigate={() => setIsMobileMenuOpen(false)} />
        </div>
      </div>

      <div className="w-fit fixed z-40">
        <div className="w-fit relative">
          <Sidebar isCollapsed={isCollapsed} />
          <Button
            variant="ghost"
            className="absolute top-1 hidden md:flex -right-2 bg-accent w-5 p-0 h-5 border-input border cursor-pointer"
            size="sm"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            {isCollapsed ? <ChevronsLeftRight className="h-3 w-3" /> : <ChevronsRightLeft className="h-3 w-3" />}
          </Button>
        </div>
      </div>
      <main className={cn('bg-background w-full min-h-screen pt-14 md:pt-0', isCollapsed ? 'ml-[50px]' : 'md:ml-[220px]')}>{children}</main>
    </div>
  );
}
